export default "__VITE_ASSET__CQQU1fjq__"